import { render, staticRenderFns } from "./NavBlock.vue?vue&type=template&id=44131abf&"
import script from "./NavBlock.vue?vue&type=script&lang=js&"
export * from "./NavBlock.vue?vue&type=script&lang=js&"
import style0 from "./NavBlock.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports